<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'self-assess',
    subject: 'Accreditation',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-medal-line',
  color: 'warning',
  title: 'Self-Assessment Akreditasi',
  description: 'Mengisi skor per Elemen Penilaian (EP) standar akreditasi, dan mengajukan status Tidak Dapat Diterapkan (TDD).',
  purpose: 'Panduan mengisi self-assessment kesiapan akreditasi fasilitas Anda, standar demi standar.',
  concept: [
    {
      icon: 'ri-git-merge-line',
      title: 'Bab → Standar → Elemen Penilaian',
      text: 'Standar akreditasi tersusun tiga tingkat: Bab (paling umum), berisi beberapa Standar, tiap Standar berisi beberapa Elemen Penilaian (EP) — EP inilah yang benar-benar Anda beri skor satu per satu.',
    },
    {
      icon: 'ri-forbid-line',
      title: 'Tidak Dapat Diterapkan (TDD)',
      text: 'Kalau ada EP yang memang tidak relevan untuk fasilitas Anda (mis. standar khusus rumah sakit besar untuk klinik kecil), Anda bisa mengajukan status TDD — tapi harus disetujui surveyor dulu, tidak otomatis diterima.',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → Self-Assessment, pilih LPA & Jenis Fasilitas', detail: 'Mulai sesi baru, atau lanjutkan sesi yang sudah berjalan.' },
    { title: 'Pilih satu Bab, lalu satu Standar, lalu satu EP', detail: 'Struktur tampil sebagai pohon yang bisa dibuka/tutup.' },
    { title: 'Isi skor EP tersebut, dan lampirkan bukti pendukung', detail: 'Setiap EP butuh bukti (dokumen/foto) yang membuktikan pencapaiannya.' },
    { title: 'Kalau EP tidak relevan, klik "Ajukan TDD"', detail: 'Isi alasan pengajuan — status EP jadi "Menunggu Persetujuan TDD" sampai surveyor memutuskan.' },
    { title: 'Pantau progres kesiapan di bagian atas halaman', detail: 'Persentase pencapaian dihitung otomatis dan diperbarui setiap kali Anda menyimpan skor.' },
  ],
  warning: 'Pengajuan TDD yang sudah ditolak surveyor tidak bisa diajukan ulang untuk EP yang sama — pastikan alasan Anda kuat sebelum mengajukan.',
  tips: [
    'Kerjakan self-assessment secara bertahap, tidak harus sekali duduk — progres tersimpan otomatis per EP.',
    'Lampirkan bukti SEBELUM mengisi skor kalau memungkinkan, supaya reviewer bisa langsung menilai kelengkapannya.',
  ],
  faq: [
    { q: 'Apakah skor self-assessment saya bisa dilihat pihak luar?', a: 'Ada fitur "Ringkasan Publik" berupa tautan khusus yang bisa dibagikan — tapi hanya dibuat kalau admin sengaja membuatnya, tidak otomatis publik.' },
    { q: 'Kalau EP saya ditolak TDD, apa saya masih bisa mengisi skornya?', a: 'Bisa — penolakan TDD justru membuka kembali EP itu untuk dinilai secara normal.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
